import { Link } from "react-router-dom";

function TermsOfService() {
  return (
    <div className="privacy-policy-container">
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> January 23rd, 2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using our Website, you confirm that you are at least 18 years old or have parental/guardian consent if under 18. You agree to follow all applicable laws and regulations while using the Website.
      </p>

      <h2>2. Services Provided</h2>
      <p>
        Our Website provides information about futsal courts, including locations, amenities, and user-submitted reviews. We do not own or operate these courts, and the information presented is for informational purposes only.
      </p>

      <h2>3. User Accounts & Conduct</h2>
      <p>
        You may be required to create an account to submit reviews or add futsal court listings. You agree to provide accurate and truthful information. You may not use the Website for any illegal, fraudulent, or harmful activities, including:
      </p>
      <ul>
        <li>Submitting false court listings or reviews.</li>
        <li>Harassing or misleading other users.</li>
        <li>Attempting to hack, scrape, or misuse the Website’s data.</li>
      </ul>
      <p>
        If you violate these terms, we reserve the right to suspend or terminate your account.
      </p>

      <h2>4. Court Listings & Reviews</h2>
      <p>
        Court information is user-submitted and may not always be accurate. We encourage users to verify details before visiting a venue. You may submit reviews and updates, but they must be honest and respectful. We reserve the right to edit, remove, or refuse any content that violates our policies.
      </p>

      <h2>5. Third-Party Links & Services</h2>
      <p>
        Our Website may contain links to third-party websites (e.g., official futsal venue pages). We do not endorse or control these sites and are not responsible for their content or services.
      </p>

      <h2>6. Liability Disclaimer</h2>
      <p>
        We strive to provide accurate and up-to-date information, but we do not guarantee the accuracy, reliability, or availability of any court listings. We are not responsible for any accidents, injuries, damages, or losses incurred at listed venues. Your use of the Website is at your own risk.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content on the Website, including logos, text, and design elements, is our property or licensed to us. You may not copy, reproduce, or distribute any content without permission.
      </p>

      <h2>8. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Any changes will be posted on this page with a revised effective date. Your continued use of the Website signifies acceptance of the updated Terms.
      </p>

      <h2>9. Termination</h2>
      <p>
        We reserve the right to terminate or restrict access to our Website for any user who violates these Terms or engages in harmful activity.
      </p>

      <h2>10. Contact Us</h2>
      <p>If you have questions about these Terms, please contact us at:</p>
      <p><strong>Email:</strong> <a href="mailto:thefutsaldirectory@gmail.com">thefutsaldirectory@gmail.com</a></p>

      <div className="privacy-back">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}

export default TermsOfService;
